import { inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpRequest, HttpInterceptorFn } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { StorageHelper } from '@diktup/frontend/helpers';

export const authInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
  const storageHelper = inject(StorageHelper);
  const router = inject(Router);

  const token = storageHelper.getData('token');
  const newRequest = req.clone({
    setHeaders: {
      app: 'SIFCA',
      platform: 'web',
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    }
  });

  return next(newRequest).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error instanceof HttpErrorResponse) {
        if (error.status === 401) {
            // Sign out
            localStorage.removeItem('token');
            // Reload the app
            location.reload();
          }
          if (error.status === 500) {
            router.navigateByUrl('/pages/error/500');
          }
      } else {
        console.error('Something else happened');
      }
      return throwError(() => error);
    })
  );
};